import React from "react";
import { MenuItem, makeStyles, TextField } from "@material-ui/core";

import I18nText from "../../../../../../elements/I18nText";
import { useTankGeometries } from "../../../../../../domain/tankGeometry";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%"
  }
}));

const GeometrySelect = React.memo(
  ({ prefix, geometry, setFieldValue, size = "small" }) => {
    const tankGeometries = useTankGeometries();
    const classes = useStyles();
    const name = `${prefix}.geometry`;

    const options = [...tankGeometries];

    options.sort((a, b) => {
      return a.name < b.name;
    });

    if (options.length === 0) {
      return null;
    }

    return (
      <TextField
        classes={classes}
        variant="outlined"
        value={geometry}
        size={size}
        select
        name={name}
        inputProps={{
          id: name
        }}
        onChange={e => setFieldValue(name, e.target.value)}
      >
        {options.map(option => (
          <MenuItem key={option} value={option}>
            <I18nText>{`sensors.tankGeometries.${option}`}</I18nText>
          </MenuItem>
        ))}
      </TextField>
    );
  }
);

export default GeometrySelect;
